import React, { useEffect, useState } from "react";
import TradingViewWidget from 'react-tradingview-widget';
import { Container, Row, Col, Button } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Graph = () => {

    const params = useParams();
    const [isView, setView] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const { t } = useTranslation();

    useEffect(() => {
        setView(true);

    }, [])

    const handleBack = () => {
        navigate(-1);
    };


    /**
        * Used for render the crypto graph UI
        */
    return (
        <section className="home_banner_main buy_page position-relative">
            <Container>
                <div className="d-flex align-items-center mb-3 ">
                    <Link to="" onClick={handleBack} className="arrow_back me-3">
                        <svg
                            role="button"
                            width="25"
                            height="25"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 10"
                        >
                            <path
                                stroke="#000"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                                d="M13 5H1m0 0 4 4M1 5l4-4"
                            />
                        </svg>
                    </Link>

                    <h4 className="text-start mt-2">{params?.symbol} {"("+location?.state?.name+")"}</h4>
                </div>
                {
                    isView &&
                    <div className="graph_wrap">
                        <TradingViewWidget symbol={params?.symbol} />
                    </div>
                }
            </Container>
        </section>

    )


}

export default Graph;